import { z } from 'zod';

export const FilterInfoGetResponse = z.object({
  scanners: z.record(z.string(), z.array(z.union([z.number(), z.literal('unknown')]))),
  staining: z.array(z.string()).prefault([]),
  customField1: z.array(z.string()).prefault([]),
});
export type FilterInfoGetResponseType = z.infer<typeof FilterInfoGetResponse>;
